// src/components/Home/KeyStatisticsSection.jsx
import shapeImg from "../../assets/images/landing/shape-img.png";
import Image from "../common/Image";
import { useLanguage } from "../LanguageProvider/LanguageProvider";
import icon1 from "../../assets/images/landing/key-icon-1.svg";
import icon2 from "../../assets/images/landing/key-icon-2.svg";
import icon3 from "../../assets/images/landing/key-icon-3.svg";
import icon4 from "../../assets/images/landing/key-icon-4.svg";
import { useEffect, useState } from "react";
import api from "../../api/ApiService";

const KeyStatisticsSection = () => {
  const { language } = useLanguage();

  const formatNumber = (value) => {
    if (value === null || value === undefined) return 0;

    const num = Number(value);

    if (num % 1 !== 0) {
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return num.toLocaleString("en-IN");
  };

  const [statsData, setStatsData] = useState({
    total_registered: 0,
    completed: 0,
    under_construction: 0,
    not_started: 0,
    total_investment_proposed: 0,
  });

  const formatDynamicValue = (label, value, language) => {
    const num = Number(value);

    if (!num || num === "0") {
      return language ? "प्रतीक्षा हो रही है..." : "Awaiting..";
    }

    return formatNumber(num);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await api.get("/statistics");
      setStatsData(res);
    } catch (err) {
      console.error("Stats API error", err);
    }
  };

  const dynamicStats = [
    {
      icon: icon1,
      value: formatDynamicValue(
        { en: "Proposed Investment(INR Cr)" },
        statsData?.total_investment_proposed,
        language,
      ),
      label: {
        en: "Proposed Investment(INR Cr)",
        hi: "कुल प्रस्तावित निवेश(करोड़ में)",
      },
    },
    {
      icon: icon2,
      value: formatDynamicValue(
        { en: "Proposed Employment" },
        statsData?.employment,
        language,
      ),
      label: {
        en: "Proposed Employment",
        hi: "कुल प्रस्तावित रोजगार",
      },
    },
    {
      icon: icon3,
      value: formatDynamicValue(
        { en: "Registered Investor" },
        statsData?.total_registered,
        language,
      ),
      label: {
        en: "Registered Investor",
        hi: "कुल पंजीकृत निवेशक",
      },
    },
    {
      icon: icon4,
      value: formatDynamicValue(
        { en: "Completed" },
        statsData?.completed,
        language,
      ),
      label: {
        en: "Completed",
        hi: "पूर्ण",
      },
    },
  ];

  return (
    <section
      className="bg-[#fbecd9] key-statistics -mt-12 pt-20 pb-16"
      id="Statistics"
    >
      <div className="max-w-7xl mx-auto px-4">
        {/* Title */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            {language ? "प्रमुख आँकड़े" : "Key Statistics"}
          </h2>
          <p className="text-gray-600 max-w-2xl">
            {language
              ? "उत्तराखण्ड में पर्यटन उद्योग ने हाल के वर्षों में उल्लेखनीय वृद्धि दर्ज की है, जिसका प्रमुख कारण धार्मिक पर्यटन, साहसिक खेलों एवं इको-टूरिज्म जैसे विविध क्षेत्रों में उपलब्ध व्यापक संभावनाएँ हैं।"
              : "The tourism industry in Uttarakhand has experienced significant growth in recent years, driven by its diverse offerings in religious tourism, adventure sports, and eco-tourism."}
          </p>
        </div>

        {/* Content */}
        <div className="flex flex-col md:flex-row md:space-x-8 space-y-8 md:space-y-0 items-center">
          {/* Image Cluster */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="w-full h-full flex justify-center items-center">
              <Image
                src={shapeImg}
                alt="Shape"
                className="w-80 h-full object-cover rounded-lg"
              />
            </div>
          </div>

          {/* Statistics Section */}
          <div className="w-full md:w-full">
            {/* Title */}
            {/* <h2 className="text-2xl font-bold mb-6 text-center md:text-center">
              {language ? "निवेश" : "Investment"}
            </h2> */}

            {/* Statistics Boxes */}
            <div className="grid grid-cols-2 gap-6">
              {dynamicStats?.map((stat, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-lg shadow p-4 flex items-center"
                >
                  <div className="text-green-500 text-3xl mr-4">
                    <Image
                      src={stat.icon}
                      alt={`Icon ${idx + 1}`}
                      className="w-10 h-10 sm:w-10 sm:h-10 md:w-10 md:h-10"
                    />
                  </div>

                  <div className="text-left">
                    <p className="text-[#018f9b] text-xl font-bold">
                      {stat.value}
                    </p>
                    <p className="text-gray-600">
                      {language ? stat.label.hi : stat.label.en}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyStatisticsSection;
